import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "./UserContext";
import {API_URL} from "../App";

import axios from "axios";


const fetchTwitchUser = async (token) => {

  try {
    const response = await axios.get("https://api.twitch.tv/helix/users", {
      headers: {
        "Authorization": `Bearer ${token}`,
        "Client-Id": "dc5o9xs32z5di1jjviy56vhmlqvjnc",
      },
    });
    if (response.data && response.data.data.length > 0) {
      return response.data.data[0]; // User info is in the first element of the `data` array
    } else {
      throw new Error("No user data found.");
    }

  } catch (error) {
    //console.error("Error fetching user data:", error);
  }
};



const CallbackPage = () => {
  const { user, setUser } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    const hash = window.location.hash.substring(1); // Extract hash fragment
    const params = new URLSearchParams(hash);
    const token = params.get("access_token");

    if (token) {
      localStorage.setItem("twitchToken", token); // Save token for API requests
      fetchTwitchUser(token).then((userData) => {
        if (userData) {
          try {
            axios.get(`${API_URL}/api/register-user`, {
              headers: {
                "userData": JSON.stringify(userData)
              }
            })
            setUser(userData);
            navigate("/leaderboard");
            
          } catch (error) {
            console.error("Error fetching user data:", error);
            localStorage.clear();
            navigate("/")
          } 
        }
      });
    } else {
      //const d = {id: "144201693", login: "seedsmash", display_name: "SeedSmash", type: "", broadcaster_type: "", description: "(Welcome to Seedsmash! This channel offers a unique and interactive experience where viewers will soon be able to enter a bot tournament by submitting custom bot configurations. Choose your character, set playstyle preferences, and watch as your bot learns and competes live!", profile_image_url: "https://static-cdn.jtvnw.net/jtv_user_pictures/766c6b9e-4898-4973-b9e3-95ca8851d538-profile_image-300x300.png", offline_image_url: "", view_count: 0, email: "vvillin@hotmail.fr"}
      //setUser(d)
      //navigate("/leaderboard");
      console.error("Failed to retrieve token");
      localStorage.clear();
      navigate("/")
    }
  }, [navigate]);

  return (
      <div> Logging in...</div>
      );
};

export default CallbackPage;